export function showTrailerInfo() {
  const { messages = {} } = window.translationsAndConfigs || {};
  const trailerInfoContainer = document.createElement('DIV');
  trailerInfoContainer.className = 'trailerInfoContainer';
  trailerInfoContainer.innerText = messages.Player_Msg_WatchingTrailer;
  const videoContainer = document.querySelector('.playerComp');
  if (videoContainer) videoContainer.appendChild(trailerInfoContainer);
}
